module.exports = __webpack_public_path__ + "media/testimonials/customer-4-a5607ca6.png";